export default __webpack_public_path__ + "static/media/2cf578349bdfd8ba9987e77eb22bfa9f.svg";